import { strippedURL } from './strippedURL';

export function useRenderRichText (text) {
  const replacer = (match, p1) => match.replace(p1, strippedURL(p1));

  return renderRichText(text).replaceAll(/href=["'](.*?)["']/g, replacer);
}